<script lang="ts">
	import type { Device } from 'src/types/Device';
	import type { VentoraSensorKind } from 'src/helpers/sensor_config_helpers';
	import SensorComponentNameG2 from '../SensorComponentNameG2.svelte';
	import DarkThresholdG2 from '../Illuminance/DarkThresholdG2.svelte';
	import BrightThresholdG2 from '../Illuminance/BrightThresholdG2.svelte';
	import HumidityOffsetG2 from '../Offset/HumidityOffsetG2.svelte';
	import HumidityThreshold from '../HumidityThreshold.svelte';
	import TemperatureOffsetG2 from '../Offset/TemperatureOffsetG2.svelte';
	import TemperatureThreshold from '../TemperatureThreshold.svelte';

	export let device: Device;
	export let sensorKind: VentoraSensorKind;
</script>

<div class="ventora-sensor-settings-group">
	<SensorComponentNameG2 {device} {sensorKind} />

	{#if sensorKind === 'illuminance'}
		<hr class="mb-m mt-m" />
		<DarkThresholdG2 {device} />
		<hr class="mb-m mt-m" />
		<BrightThresholdG2 {device} />
	{:else if sensorKind === 'humidity'}
		<hr class="mb-m mt-m" />
		<HumidityOffsetG2 {device} />
		<hr class="mb-m mt-m" />
		<HumidityThreshold {device} />
	{:else}
		<hr class="mb-m mt-m" />
		<TemperatureOffsetG2 {device} />
		<hr class="mb-m mt-m" />
		<TemperatureThreshold {device} />
	{/if}
</div>
